import * as dagre from '@dagrejs/dagre';
import { ComputationGraph, LayoutGraph, LayoutNode, LayoutEdge } from './types';

const NODE_WIDTH = 140;
const NODE_HEIGHT = 60;

export function layoutGraph(graph: ComputationGraph): LayoutGraph {
  const g = new dagre.graphlib.Graph<{
    label: string;
    width: number;
    height: number;
  }>();
  g.setGraph({ rankdir: 'LR', ranksep: 80, edgesep: 20, nodesep: 30 });
  g.setDefaultEdgeLabel(() => ({}));

  for (const node of graph.nodes) {
    g.setNode(node.id, {
      label: node.label,
      width: NODE_WIDTH,
      height: NODE_HEIGHT
    });
  }

  for (const edge of graph.edges) {
    g.setEdge(edge.from, edge.to);
  }

  dagre.layout(g);

  const nodes: LayoutNode[] = graph.nodes.map((node) => {
    const dagreNode = g.node(node.id);
    return {
      ...node,
      x: dagreNode.x,
      y: dagreNode.y,
      width: dagreNode.width,
      height: dagreNode.height
    };
  });

  const edges: LayoutEdge[] = graph.edges.map((edge) => {
    const e = g.edge(edge.from, edge.to);
    return {
      ...edge,
      points: (e.points ?? []).map((p) => ({ x: p.x, y: p.y }))
    };
  });

  const graphWidth = g.graph().width ?? 0;
  const graphHeight = g.graph().height ?? 0;

  return {
    nodes,
    edges,
    width: graphWidth + NODE_WIDTH,
    height: graphHeight + NODE_HEIGHT
  };
}
